import { render, staticRenderFns } from "./DealForm.vue?vue&type=template&id=2f9988d0&"
import script from "./DealForm.vue?vue&type=script&lang=ts&"
export * from "./DealForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports